import { Card } from "../CardAB";
import { PhotoSwitcher } from "./PhotoSwitcher";

export class Fast
{
    constructor(element, id = undefined)
    {
        this.element = element;
        this.id = id || this.element.dataset.id;

        this.modal = null;
        this.nestedModals = null;

        if (!this.id) {
            throw new Error(`can't find element id`);
        }

        this.bindEvents();
    }

    bindEvents()
    {
        this.element?.addEventListener('click', e => {
            e.preventDefault();
            this.load();
        });
    }

    load()
    {
        this.request()
            .then(r => this.processLoaded(r))
            .then(() => this.show());
    }

    processLoaded(result)
    {
        const processedResult = BX.processHTML(result);
        const content = BX.Tag.render`<div data-entity="fast-view-content">${processedResult.HTML}</div>`;
        
        const modal = BX.Tag.render`
            <div class="modal fade" id="fast_card">
                <div class="modal-dialog modal-fast-view">
                    <div class="modal-content">
                        <div class="modal-body fast-view">
                            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1 1L23 23M23 1L1 23" stroke="black" stroke-width="2" stroke-linecap="round"/>
                                </svg>
                            </button>
                            <div class="modal-fast-view-content">${content}</div>
                        </div>
                    </div>
                </div>
            </div>
        `;

        this.modal = modal;

        this.nestedModals = content.querySelector(`[data-entity="fast-card-modals"]`);

        BX.Dom.append(this.nestedModals, document.body);
        BX.Dom.append(this.modal,document.body);

        return this.loadDependencies(processedResult);
    }

    show()
    {
        $(this.modal).modal('show');
        $(this.modal).on('shown.bs.modal', () => {
            this.init();
        });
        $(this.modal).on('hidden.bs.modal', () => {
            this.dispose();
        });
    }

    init()
    {
        new Card();
        new PhotoSwitcher({ zoom: false });

        bindFindOutMySize(this.modal);
        bindBasketAdd(this.modal);
        bindPopupBtn(this.modal);

        $(this.modal).find('.js-ab-slider_thumb')
            .slick({
                vertical: true,
                slidesToShow: 7,
                slidesToScroll: 1,
                verticalSwiping: true,
                prevArrow: '<span class="card__slider_up"></span>',
                nextArrow: '<span class="card__slider_down"></span>',
                responsive: [
                    { breakpoint: DESKTOP_BREAKPOINT, settings: { slidesToShow: 5 } },
                    { breakpoint: TABLET_BREAKPOINT,  settings: { slidesToShow: 3 } }
                ]
            });

        $(this.modal).find('#slider-container')
            .slick({
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true
            })
            .on('afterChange', (event, slick, currentIndex) => {
                let currentSlide = $(`[data-slick-index=${currentIndex}]`);
                if (currentSlide.is('video')) {
                    currentSlide.trigger('play');
                }
            });

        [...this.nestedModals.children].forEach(el => {
            $(el).on('show.bs.modal', () => {
                this.modal.style.zIndex = 900;
            });
            $(el).on('hide.bs.modal', () => {
                this.modal.style.removeProperty('z-index');
            });
            $(el).on('hidden.bs.modal', () => {
                document.body.classList.add('modal-open');
            });
        });

        [...this.modal.querySelectorAll('[data-trigger="switch-color"]')]
            .forEach(el => el.addEventListener('click', e => {
                e.preventDefault();
                this.switchElement(el.dataset.elementId)
            }));
    }

    switchElement(elementId)
    {
        this.id = elementId;
        
        const $modalContent = $(this.modal).find('.modal-content');

        $modalContent.preloader('show');
        this.request()
            .then(r => this.processSwitch(r))
            .then(() =>  {
                setTimeout(() => {
                    $modalContent.preloader('hide');
                    this.init();
                }, 100);
            });
    }

    processSwitch(result)
    {
        const processedResult = BX.processHTML(result);
        const content = BX.Tag.render`<div data-entity="fast-view-content">${processedResult.HTML}</div>`;
        
        BX.Dom.replace(
            this.modal.querySelector('[data-entity="fast-view-content"]'),
            content
        );

        const nestedModals = content.querySelector(`[data-entity="fast-card-modals"]`);
        BX.Dom.replace(
            this.nestedModals,
            nestedModals
        );

        this.nestedModals = nestedModals;

        return this.loadDependencies(processedResult);
    }

    loadDependencies(processedResult)
    {
        BX.loadCSS('/assets/styles/card_fast.css');
        BX.ajax.processScripts(processedResult.SCRIPT);
    }

    request()
    {
        return new Promise((resolve, reject) => {
            $.get(`/show/catalog/fast/${this.id}/`)
                .done(resolve)
                .fail(reject);
        });
    }

    dispose()
    {
        this.modal.remove();
        this.nestedModals.remove();

        this.modal = null;
        this.nestedModals = null;
    }
}
